/* istanbul ignore file */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable import/no-self-import */
import getConfig from 'next/config';
import api from '../axios';

const {
  publicRuntimeConfig: { sessionApiUrl },
} = getConfig();

const sessionApi = api(sessionApiUrl);

export const getSession = async () => {
  try {
    const { sessionId } = await sessionApi.post('/session', {
      withCredentials: true,
    });

    return sessionId;
  } catch (ex) {
    return Promise.reject(ex);
  }
};
